import React, { useContext, useEffect, useState } from "react";
import {
  TextField,
  Button,
  Snackbar,
  Grid,
  Typography,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Alert, DatePicker } from "@mui/lab";
import axios from "axios";
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";
import AppContext from "../context/AppContext";

const AddAssetForm = () => {
  const storedUserRole = localStorage.getItem('userRole');

  const [input, setInput] = useState({
    category: "",
    description: "",
    asset_name: "",
    manufacturer: "",
    purchase_date: "",
    purchase_cost: "",
    warranty_expiration_date: "",
    primary_location_name: "",
    status: "",
    id: "",
  });
  const [update, setUpdate] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [assetData, setAssetData] = useState([]);
  const { asset, setAsset } = useContext(AppContext);
  const { category, location, userRole, loadingAssets } = useContext(AppContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(()=>{
    const handleResize = ()=> setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return ()=> window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/add/assets`,
        {
          category_name: input.category,
          description: input.description,
          asset_name: input.asset_name,
          manufacturer: input.manufacturer,
          purchase_date: input.purchase_date,
          purchase_cost: input.purchase_cost,
          warranty_expiration_date: input.warranty_expiration_date,
          primary_location_name: input.primary_location_name,
          status: input.status,
        }
      );
      if (response.data.status == "success") {
        setInput({
          ...input,
          category: "",
          description: "",
          asset_name: "",
          manufacturer: "",
          purchase_date: "",
          purchase_cost: "",
          warranty_expiration_date: "",
          primary_location_name: "",
          status: "",
        });
        // setAsset([{...response.data.asset_data}, ...asset])
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
        setOpenModal(false);
      }
    } catch (error) {
      console.log({ error });
      setMessage(error.response?.data?.error || "Failed to add asset");
      setSeverity("error");
      setOpen(true);
    }
  };
  const handleSubmitUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/update/assets`,
        {
          category_name: input.category,
          description: input.description,
          asset_name: input.asset_name,
          manufacturer: input.manufacturer,
          purchase_date: input.purchase_date,
          purchase_cost: input.purchase_cost,
          warranty_expiration_date: input.warranty_expiration_date,
          primary_location_name: input.primary_location_name,
          status: input.status,
          asset_id: input.id,
        }
      );
      if (response.data.status == "success") {
        setInput({
          ...input,
          category: "",
          description: "",
          asset_name: "",
          manufacturer: "",
          purchase_date: "",
          purchase_cost: "",
          warranty_expiration_date: "",
          primary_location_name: "",
          status: "",
        });
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
        setOpenModal(false);
      }
    } catch (error) {
      console.log({ error });
      setMessage(error.response?.data?.error || "Failed to Update asset");
      setSeverity("error");
      setOpen(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const assetResponse = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/assets`
        );
        if (assetResponse.data.status === "success") {
          setAsset(assetResponse.data.assets);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [open]);

  const handleUpdate = (row) => {
    setUpdate(true);
    setInput({
      category: row.category_name,
      description: row.description,
      asset_name: row.asset_name,
      manufacturer: row.manufacturer,
      purchase_date: row.purchase_date,
      purchase_cost: row.purchase_cost,
      warranty_expiration_date: row.warranty_expiration_date,
      primary_location_name: row.primary_location_name,
      status: row.status,
      id: row.id,
    });
    setOpenModal(true);
  };

  const handleDelete = async (row) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/delete/assets`,
        { asset_id: row.id }
      );
      if (response.data.status == "success") {
        setInput({
          ...input,
          category: "",
          description: "",
          asset_name: "",
          manufacturer: "",
          purchase_date: "",
          purchase_cost: "",
          warranty_expiration_date: "",
          primary_location_name: "",
          status: "",
        });
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
        setOpenModal(false);
      }
    } catch (err) {
      console.log(err);
      setMessage(err.response.data.error || "Failed to Delete Assets");
      setSeverity("error");
      setOpen(true);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "S.No",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL.No "}</strong>
      ),
      filterable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "asset_name",
      headerName: "ASSET NAME",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"ASSET NAME "}</strong>
      ),
    },
    {
      field: "category_name",
      headerName: "CATEGORY",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"CATEGORY "}</strong>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Description "}</strong>
      ),
      renderCell: (params) => <div>{params.row.description || "NA"}</div>,
    },
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Manufacturer "}</strong>
      ),
    },
    {
      field: "purchase_date",
      headerName: "Date of purchase",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Date of purchase "}
        </strong>
      ),
    },
    {
      field: "purchase_cost",
      headerName: "Purchase Cost",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Purchase Cost "}
        </strong>
      ),
    },
    {
      field: "warranty_expiration_date",
      headerName: "Warranty Expiration Date",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Warranty Expiration Date "}
        </strong>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Status "}</strong>
      ),
    },
    {
      field: "last_maintenance_date",
      headerName: "Last Maintainence Date",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Last Maintainence Date "}
        </strong>
      ),
      renderCell: (params) => (
        <div>{params.row.last_maintenance_date || "NA"}</div>
      ),
    },
    {
      field: "primary_location_name",
      headerName: "Primary Location Name",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Primary Location Name "}
        </strong>
      ),
    },
    {
      field: "last_maintenance_cost",
      headerName: "Last Maintainence Price",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Last Maintainence Price "}
        </strong>
      ),
      renderCell: (params) => (
        <div>{params.row.last_maintenance_cost || "NA"}</div>
      ),
    },
    {
      field: "distance",
      headerName: "Distance",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderHeader: () => ( 
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Distance "}</strong>
      ),
      renderCell: (params) => <div>{params.row.distance || "NA"}</div>,
    },
    {
      field: "beacon_mac",
      headerName: "Beacon Mac Address",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Beacon Mac Address "}
        </strong>
      ),
      renderCell: (params) => <div>{params.row.beacon_mac || "NA"}</div>,
    },
    {
      field: "ts",
      headerName: "Asset Creation Time",
      width: 180,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Asset Creation Time "}
        </strong>
      ),
    },
    {
      field: "update",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}></strong>
      ),
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{ borderRadius: 25, fontSize: 9, padding: 4, backgroundColor: storedUserRole == 'demo' ? 'grey': '' }}
          onClick={() => storedUserRole == 'demo' ? '' : handleUpdate(params.row)}
        >
          Update
        </Button>
      ),
    },
    {
      field: "delete",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}></strong>
      ),
      renderCell: (params) => {
        if (userRole == "napino") {
          return null;
        }

        return (
          <Button
            variant="contained"
            style={{ borderRadius: 25, fontSize: 9, padding: 4, backgroundColor: storedUserRole == 'demo' ? 'grey': '' }}
            onClick={() => storedUserRole == 'demo' ? '' : handleDelete(params.row)}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = async () => {
    setUpdate(false);
    setInput({
      category: "",
      description: "",
      asset_name: "",
      manufacturer: "",
      purchase_date: "",
      purchase_cost: "",
      warranty_expiration_date: "",
      primary_location_name: "",
      status: "",
    });
    setOpenModal(true);
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography
          style={{
            display: "flex",
            justifyContent: "flex-end",
            border: "none",
            backgroundColor: "transparent",
            cursor: "pointer",
            color: storedUserRole == 'demo' ? 'grey' :'green',
            fontSize: 18,
          }}
           onClick={storedUserRole == 'demo' ? ()=> '' : handleOpenModal}
        >
          + Add Asset
        </Typography>
        <DataGrid
          rows={asset}
          rowSelection={false}
          getRowId={(row) => row.id}
          columns={columns}
          loading={loadingAssets}
          pageSize={10}
          density="compact"
          rowsPerPageOptions={[10, 20, 30]}
          components={{ Toolbar: GridToolbar,
             FilterPanel: GridFilterPanel,
           }}
           slotProps={{
          filterPanel: {
            sx: {
              width: "100%",          // full width responsive
              maxWidth: "100%",
              padding: "10px",
              "& .MuiDataGrid-filterForm": {
                flexDirection: "column",
                gap: "10px",
              },
            },
          },
        }}
          pagination
          style={{
            backgroundColor: 'white',
            minHeight: 200
          }}
        />
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",

              width:isMobile ? 300 : 400,
              maxHeight: "100%",

              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "white",
              boxShadow: 24,
              padding: "20px",
              marginTop : "1rem"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "flex-end",
                cursor: "pointer",
              }}
              onClick={handleCloseModal}
            >
              <img style={{ width: 20, height: 20 }} src="/Close.png" />
            </div>
            <form
              onSubmit={update ? handleSubmitUpdate : handleSubmit}
              style={{ flexDirection: "column", display: "flex", marginTop: "1rem" }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <FormControl style={{ marginTop: "12px" }}>
                    <InputLabel id="asset-select-label">Category</InputLabel>

                    <Select
                      labelId="asset-select-label"
                      id="asset-select"
                      name="category"
                      value={input.category}
                      onChange={(e) => handleInputChange(e)}
                      label="Select category"
                      style={{ width: isMobile ? 250 : 165 }}
                    >
                      {category?.map((asset) => (
                        <MenuItem key={asset.id} value={asset.category_name}>
                          {" "}
                          {asset.category_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Description"
                    name="description"
                    value={input.description}
                    onChange={(e) => handleInputChange(e)}
                    style={{ marginTop: "12px", width: isMobile ? 250 : "" }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl margin="normal">
                    <InputLabel id="asset-select-label">
                      Primary Location
                    </InputLabel>
                    <Select
                      labelId="asset-select-label"
                      id="asset-select"
                      name="primary_location_name"
                      value={input.primary_location_name}
                      onChange={(e) => handleInputChange(e)}
                      label="Select Location"
                      style={{ width: isMobile ? 250  : 165 }}
                    >
                      {location?.map((asset) => (
                        <MenuItem key={asset.id} value={asset.name}>
                          {" "}
                          {asset.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl margin="normal">
                    <InputLabel id="asset-select-label">Status</InputLabel>
                    <Select
                      labelId="asset-select-label"
                      id="asset-select"
                      name="status"
                      value={input.status}
                      onChange={(e) => handleInputChange(e)}
                      label="Select Location"
                      style={{ width:isMobile ? 250  : 165 }}
                    >
                      {[
                        { id: "1", name: "Active" },
                        { id: "2", name: "Inactive" },
                      ]?.map((asset) => (
                        <MenuItem key={asset.id} value={asset.name}>
                          {" "}
                          {asset.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Asset Name"
                    name="asset_name"
                    value={input.asset_name}
                    onChange={(e) => handleInputChange(e)}
                    style={{width: isMobile ? 250  : ""}}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Manufacturer"
                    name="manufacturer"
                    value={input.manufacturer}
                    onChange={(e) => handleInputChange(e)}
                    style={{width: isMobile ? 250  : ""}}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Purchase Date"
                    name="purchase_date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={input.purchase_date}
                    onChange={(e) => handleInputChange(e)}
                    style={{width: isMobile ? 250  : ""}}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Purchased Cost"
                    name="purchase_cost"
                    value={input.purchase_cost}
                    onChange={(e) => handleInputChange(e)}
                    style={{width: isMobile ? 250  : ""}}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Warranty Expiration Date"
                    name="warranty_expiration_date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={input.warranty_expiration_date}
                    onChange={(e) => handleInputChange(e)}
                    style={{ marginBottom: "12px", width : isMobile ? 250 : "" }}
                  />
                </Grid>
              </Grid>
              <Button type="submit" variant="contained" color="primary">
                {update ? "Update" : "Add"}
              </Button>
            </form>
          </div>
        </Modal>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>
      </Grid>
    </Grid>
  );
};

export default AddAssetForm;
